import { type CheckoutCheckboxConfig as GQLCheckoutCheckboxConfig } from '../generated/checkout.graphql';
import { take } from '../util/takePayload';

export type CheckoutCheckboxConfig = {
  key: string;
  label: string;
  required: boolean;
  description?: string;
  descriptionTitle?: string;
};

export const fromGql = (gqlItem: GQLCheckoutCheckboxConfig): CheckoutCheckboxConfig =>
  take(gqlItem, 'key', 'label', 'required', 'description', 'descriptionTitle') as CheckoutCheckboxConfig;
